var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-textarea',{class:_vm.$props.editorId})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }